// extracted by mini-css-extract-plugin
export default {"modal_container":"CharacterInfoModal_modal_container__VWX45"};